<template>
  <tm-skeleton-details-table-redesign
    v-if="isSentSms"
    preset="column-reverse"
  >
    <tm-skeleton-details-table-sms-preview />
  </tm-skeleton-details-table-redesign>
  <tm-skeleton-details-table v-else />
</template>

<script lang="ts" setup>
import { useWrapper } from '@/composition/modal'
import { messageDetailsModalId } from '@/components/domain/chats/types'
import { isModelTypeSentSmsFull, type MessageDetailsModalParams } from '@/components/shared/modals/messages/types'
import TmSkeletonDetailsTable from '@/components/shared/skeletons/TmSkeletonDetailsTable.vue'
import TmSkeletonDetailsTableRedesign from '@/components/shared/skeletons/TmSkeletonDetailsTableRedesign.vue'
import TmSkeletonDetailsTableSmsPreview from '@/components/shared/skeletons/TmSkeletonDetailsTableSmsPreview.vue'

const { modelType } = useWrapper<MessageDetailsModalParams>(messageDetailsModalId).getParams()

const isSentSms = !!modelType && isModelTypeSentSmsFull(modelType)
</script>
